import { TFunction } from 'i18next'
import React from 'react'

import { UserType } from '@/@types/global'
import { UserTypeProps } from '@/@types/userType'

type SideMenuType = {
  user: UserType | UserTypeProps | null
  redirectTo: (path: string) => void
  translate: TFunction
}

type SideMenuItemsType = {
  key: string
  icon: React.ReactNode
  label: string
  onClick: void
  roles?: Array<string>
}

export type SideMenuDataType = {
  key: string
  label: string
  roles: Array<string>
  items: Array<SideMenuItemsType>
}

export type SideMenuReturnType = Array<SideMenuDataType>

const getSideMenu = ({
  // user,
  redirectTo,
  translate,
}: SideMenuType): SideMenuReturnType => [
  {
    key: 'tpi-report',
    label: 'TPI Report',
    roles: ['admin'],
    items: [
      {
        key: 'home',
        icon: 'HomeLine',
        label: translate('sideMenu.home'),
        onClick: redirectTo('/home'),
        roles: ['admin'],
      },
      {
        key: 'generate-report',
        icon: 'FileListLine',
        label: translate('sideMenu.generateReport'),
        onClick: redirectTo('/generate-report'),
        roles: ['admin'],
      },
      {
        key: 'search-report',
        icon: 'SearchReport',
        label: translate('sideMenu.searchReport'),
        onClick: redirectTo('/search-report'),
        roles: ['admin'],
      },
      {
        key: 'permissions-management',
        icon: 'UserLine',
        label: translate('sideMenu.permissionsManagement'),
        onClick: redirectTo('/permissions-management'),
        roles: ['admin'],
      },
      {
        key: 'footer-settings',
        icon: 'ReportFooter',
        label: translate('sideMenu.footerSettings'),
        onClick: redirectTo('/footer-settings'),
        roles: ['admin'],
      },
      {
        key: 'remark-definition',
        icon: 'Remark',
        label: translate('sideMenu.remarkDefinition'),
        onClick: redirectTo('/remark-definition'),
        roles: ['admin'],
      },
      {
        key: 'search-report-orders',
        icon: 'SearchLine',
        label: translate('sideMenu.searchOrders'),
        onClick: redirectTo('/search-report-orders'),
        roles: ['admin'],
      },
      {
        key: 'approval-flow',
        icon: 'ApprovalFlow',
        label: translate('sideMenu.approvalFlow'),
        onClick: redirectTo('/approval-flow'),
        roles: ['admin'],
      },
    ],
  },
]

export const getSideMenuSettings = ({
  user,
  redirectTo,
  translate,
}: SideMenuType) => {
  return [...getSideMenu({ user, redirectTo, translate })]
}
